<div class="orgApp-add-duty-dialog-box orgapp-duty-details">
  <div class="orgApp-align-i-center orgApp-d-flex orgApp-justify-c-spc-btw orgApp-add-duty-header">
    <h2 mat-dialog-title>
      @if(canEditDuty && (!isDutyMappedToAnyLocationDepartment || isAppAdmin)){
      <b>{{ editFormData.title | translate }}</b>
      }@else{
        <b>{{ "duties.create_duty_dialog.title.read_only" | translate }}</b>
      }
    </h2>
    <button type="button" mat-icon-button class="float-right" (click)="cancelForm()">
      <svg width="24" height="24">
        <use xlink:href="#close-icon"></use>
      </svg>
    </button>
  </div>
  <mat-dialog-content class="duty-details-wrapper">
    <form [formGroup]="addDutyForm">
      <div class="orgApp-flex-dir-col orgApp-d-flex orgApp-gap-24">
        <div class="orgApp-add-duty-container1 orgApp-d-flex orgApp-gap-24 orgApp-add-duty-full-width">
          <div class="orgApp-add-duty-left-container orgApp-add-duty-full-width orgApp-flex-dir-col orgApp-gap-16 orgApp-d-flex">
            <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-padding-left-24 orgApp-padding-right-24 orgApp-gap-16">
              <div class="orgApp-d-flex orgApp-gap-16">
                <mat-button-toggle-group [disabled]="(!canEditDuty || (isDutyMappedToAnyLocationDepartment && !isAppAdmin))"
                  class="orgApp-add-duty-btn-toggle-gp orgApp-add-duty-field-div" [ngClass]="{'orgApp-ad-remove-bg-disabled':(!canEditDuty || (isDutyMappedToAnyLocationDepartment && !isAppAdmin))}"
                  [hideSingleSelectionIndicator]="true"
                  [value]="selectedDutyType"
                  (change)="onBtnToggleChange($event.value)"
                >
                  <mat-button-toggle
                    [ngClass]="{ active: selectedDutyType === 'DAY' }" value="DAY"
                    class="orgApp-duty-btn-toggle-left orgApp-add-duty-type orgApp-duty-btn-toggle"
                  >
                    {{ "duties.create_duty_dialog.content.day" | translate }}
                  </mat-button-toggle>
                  <mat-button-toggle [disabled]="hasChildShift"
                    [ngClass]="{ active: selectedDutyType === 'NIGHT' }" value="NIGHT"
                    class="orgApp-duty-btn-toggle-right orgApp-add-duty-type orgApp-duty-btn-toggle"
                  >
                    {{ "duties.create_duty_dialog.content.night" | translate }}
                  </mat-button-toggle>
                </mat-button-toggle-group>
              </div>
              <div class="orgApp-d-flex orgApp-gap-16 orgApp-margin-top-16">
                <mat-form-field
                  appearance="outline"
                  class="orgApp-add-duty-field orgApp-input-field orgApp-field-rounded-sm orgApp-add-duty-type-width orgApp-add-duty-input-field "
                >
                  <mat-label class="orgApp-add-d-graphik-text">{{ "duties.create_duty_dialog.content.label.duty_type" | translate }}</mat-label>
                  <mat-select
                    placeholder="{{ 'duties.create_duty_dialog.content.placeholder.duty_type' | translate }}"
                    formControlName="dutyState"
                    class="orgApp-add-d-type-sel"
                    [(value)]="selectedDutyState"  panelClass="orgApp-dropdwn-opt"
                    (selectionChange)="onDutyStateChange($event)"
                  >
                    @for (data of dutyState; track data) {
                    <mat-option [value]="data.value">{{ "duties.create_duty_dialog.content.label." + data.viewValue | translate }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Picket Duty -->
              <ng-container *ngIf="!addDutyForm.get('picketDuty')?.disabled; else picketIcon">
                <mat-checkbox
                  formControlName="picketDuty"
                  (change)="dutyCheckBoxOption('picketDuty',$event)"
                  color="primary"
                  class="orgApp-add-duty-picket-cb orgApp-margin-top-8">
                  {{ "duties.create_duty_dialog.content.label.mark_as_picket_duty" | translate }}
                </mat-checkbox>
              </ng-container>

              <ng-template #picketIcon>
                <ng-container *ngIf="addDutyForm.get('picketDuty')?.value">
                  <div class="orgApp-d-flex orgApp-align-i-center orgApp-gap-8 orgApp-margin-top-8">
                    <svg width="20" height="20">
                      <use [attr.xlink:href]="addDutyForm.get('picketDuty')?.value ? '#checked-true' : '#checked-false'"></use>
                    </svg>
                    <span class="orgApp-add-duty-picket-cb">
                      {{ "duties.create_duty_dialog.content.label.mark_as_picket_duty" | translate }}
                    </span>
                  </div>
                </ng-container>
              </ng-template>

              <!-- Manager Duty -->
              <ng-container *ngIf="!addDutyForm.get('managersDuty')?.disabled; else managerIcon">
                <mat-checkbox
                  formControlName="managersDuty"
                  (change)="dutyCheckBoxOption('managersDuty',$event)"
                  color="primary"
                  class="orgApp-add-duty-picket-cb">
                  {{ "duties.create_duty_dialog.content.label.manager_duty" | translate }}
                </mat-checkbox>
              </ng-container>

              <ng-template #managerIcon>
                <ng-container *ngIf="addDutyForm.get('managersDuty')?.value">
                  <div class="orgApp-d-flex orgApp-align-i-center orgApp-gap-8">
                    <svg width="20" height="20">
                      <use [attr.xlink:href]="addDutyForm.get('managersDuty')?.value ? '#checked-true' : '#checked-false'"></use>
                    </svg>
                    <span class="orgApp-add-duty-picket-cb">
                      {{ "duties.create_duty_dialog.content.label.manager_duty" | translate }}
                    </span>
                  </div>
                </ng-container>
              </ng-template>
            </div>
            <div *ngIf="selectedDutyType === 'DAY' && !addDutyForm.get('managersDuty')?.value && !addDutyForm.get('picketDuty')?.value">
              <!-- Attach the formArrayName at container level -->
              <div formArrayName="shifts">
                <mat-tab-group class="orgapp-duty-shifs-tab" [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">
                  <!-- Loop through the FormArray -->
                  <mat-tab *ngFor="let shiftCtrl of shiftsFormArray.controls as FormGroup;; let i = index">
                    <ng-template mat-tab-label>
                      <span class="orgApp-d-flex orgApp-align-i-center orgApp-gap-4">
                          <mat-checkbox
                            matTooltip="{{ 'duties.create_duty_dialog.content.label.use_this_shift' | translate }}"
                            matTooltipPosition="above"
                            color="primary"
                            [checked]="shiftCtrl.get('selected')?.value"
                            (change)="onShiftSelectedChange($event.checked, i)"
                            [disabled]="(!canEditDuty || (isDutyMappedToAnyLocationDepartment && !isAppAdmin))"
                            class="orgApp-tab-checkbox"
                          ></mat-checkbox>
                          {{ getTabLabelByShiftType(shiftCtrl.get('shiftType')?.value) }}
                      </span>
                    </ng-template>
                    <!-- Bind to each FormGroup by index -->
                    <div [formGroupName]="i"  class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16 orgApp-margin-top-8 orgApp-margin-bottom-16" [class.tab-read-onlymode]="(!canEditDuty || (isDutyMappedToAnyLocationDepartment && !isAppAdmin))">
                      <div class="orgApp-d-flex orgApp-gap-16">
                        <app-icon-color-picker
                          [disabledField]="(!canEditDuty || (isDutyMappedToAnyLocationDepartment && !isAppAdmin))"
                          [icons]="dutyIconList"
                          [colors]="colorPalette"
                          [readOnlyMode]="shiftCtrl.get('sameAsParent')?.value || !canEditDuty || (isDutyMappedToAnyLocationDepartment && !isAppAdmin)"
                          [selectedIcon]="shiftCtrl.get('icon')?.value"
                          [selectedColor]="shiftCtrl.get('colourCode')?.value"
                          [iconType]="shiftCtrl.get('iconType')?.value"
                          [iconColour]="shiftCtrl.get('iconColour')?.value"
                          [shiftType]="shiftCtrl.get('shiftType')?.value" 
                          (selectionChange)="onIconColorChange($event, shiftCtrl.get('shiftType')?.value )"
                        ></app-icon-color-picker>

                        <div *ngIf="shiftCtrl.get('shiftType')?.value !== 'FULL_DAY_DUTY' && isFullDaySelected && canEditDuty && (!isDutyMappedToAnyLocationDepartment || isAppAdmin)">
                          <mat-checkbox formControlName="sameAsParent" color="primary" (change)="onUseParentIconToggle(i)">
                            {{ 'duties.create_duty_dialog.content.label.use_full_day_icon' | translate }}
                          </mat-checkbox>
                        </div>
                        <div class="orgApp-margin-left-16 orgApp-d-flex orgApp-align-i-center orgApp-gap-8"  *ngIf="shiftCtrl.get('shiftType')?.value === 'FULL_DAY_DUTY'">
                          
                          <!-- Show Slide Toggle when editable -->
                          <mat-slide-toggle
                            *ngIf="canEditDuty && (!isDutyMappedToAnyLocationDepartment || isAppAdmin)"
                            class="orgApp-toggle-color"
                            [checked]="shiftCtrl.get('inchargeDuty')?.value"
                            (change)="onToggleChange($event, 'inchargeDuty')"
                          >
                          </mat-slide-toggle>

                          <!-- Show SVG when disabled -->
                          <svg *ngIf="!canEditDuty || (isDutyMappedToAnyLocationDepartment && !isAppAdmin)"  width="20" height="20" class="orgApp-toggle-disabled-icon">
                            <use [attr.xlink:href]="shiftCtrl.get('inchargeDuty')?.value ? '#checked-true' : '#checked-false'"></use>
                          </svg>

                          <mat-label
                            class="orgApp-add-d-graphik-text orgApp-add-d-label"
                            [ngClass]="{ 'orgApp-duties-disabled-label': !canEditDuty || (isDutyMappedToAnyLocationDepartment && !isAppAdmin) }"
                          >
                            {{ 'duties.create_duty_dialog.content.label.in_charge_duty' | translate }}
                          </mat-label>
                        </div>
                      </div>

                      <div class="orgApp-d-flex orgApp-gap-16">   
                        <mat-form-field floatLabel="always" appearance="outline"
                          class="orgApp-add-duty-field orgApp-input-field orgApp-field-rounded-sm orgApp-add-duty-code-width orgApp-add-duty-input-field "
                          [ngClass]="{ error: shiftCtrl.get('code')?.hasError('invalidFormat') }">
                          <mat-label class="orgApp-add-d-graphik-text">{{ "duties.create_duty_dialog.content.label.code" | translate }}</mat-label>
                          <input placeholder="5200" matInput id="code" formControlName="code" />
                        </mat-form-field>           
                        <mat-form-field
                          floatLabel="always"
                          appearance="outline"
                          class="orgApp-add-duty-field orgApp-input-field orgApp-add-duty-name-width orgApp-add-duty-input orgApp-field-rounded-sm "
                        >
                          <mat-label class="orgApp-add-d-graphik-text">{{ "duties.create_duty_dialog.content.label.name" | translate }}</mat-label>
                          <input
                            matInput
                            id="name"
                            formControlName="name"
                            [placeholder]="('duties.create_duty_dialog.content.placeholder.name' | translate)"
                          />
                          <mat-error *ngIf=" shiftCtrl.get('name')?.hasError('whitespace') && !shiftCtrl.get('name')?.hasError('required')">
                            {{ "common_error.whitespace_error.message" | translate }}
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div>
                        <mat-form-field
                          floatLabel="always"
                          appearance="outline"
                          class="orgApp-add-duty-field orgApp-input-field orgApp-add-duty-full-width orgApp-field-rounded-sm  orgApp-add-duty-textarea"
                        >
                          <mat-label class="orgApp-add-d-graphik-text">
                            {{ "duties.create_duty_dialog.content.label.description" | translate }}</mat-label>
                          <textarea
                            class="orgApp-add-duty-description"
                            matInput
                            id="description"
                            formControlName="description"
                            [placeholder]="('duties.create_duty_dialog.content.placeholder.description' | translate)"
                          ></textarea>
                        </mat-form-field>
                      </div>

                      <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-8">
                        <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16 orgApp-add-duty-full-width">
                          @if(shiftCtrl.get('shiftType')?.value !== 'SECOND_HALF_DAY_DUTY'){<!--Show first slot fields for all cases except second/right half duty-->
                            <div class="orgApp-d-flex orgApp-gap-8 orgApp-flex-dir-col orgApp-add-duty-time-range orgApp-padding-top-4 orgApp-padding-bottom-4 orgApp-padding-right-0 orgApp-padding-left-0 orgApp-add-duty-full-width" >
                              <div class="orgApp-d-flex orgApp-gap-8 orgApp-align-i-center orgApp-justify-c-center">
                                <mat-form-field
                                  floatLabel="always"
                                  appearance="outline"
                                  class="orgApp-add-duty-field orgApp-input-field orgApp-padding-left-6 orgApp-add-duty-range-height orgApp-field-rounded orgApp-add-duty-time-border"
                                >
                                  <input
                                    class="orgApp-add-duty-time-input orgApp-text-center"
                                    matInput
                                    type="time" (input)="breakHrVal()"
                                    formControlName="firstSlotStartTime"
                                  />
                                </mat-form-field>
                                -
                                <mat-form-field
                                  floatLabel="always"
                                  appearance="outline"
                                  class="orgApp-add-duty-field orgApp-input-field orgApp-add-duty-range-height orgApp-field-rounded orgApp-add-duty-time-border orgApp-padding-right-6"
                                  [ngClass]="{ error: shiftCtrl.get('firstSlotStartTime')?.hasError('invalidRange') || shiftCtrl.get('firstSlotEndTime')?.hasError('invalidRange') }"
                                >
                                  <input
                                    class="orgApp-add-duty-time-input orgApp-text-center"
                                    matInput
                                    type="time" (input)="breakHrVal()"
                                    formControlName="firstSlotEndTime"
                                  />
                                </mat-form-field>
                              </div>
                              <mat-error class="orgApp-text-center" *ngIf="shiftCtrl.get('firstSlotStartTime')?.hasError('invalidRange') || shiftCtrl.get('firstSlotEndTime')?.hasError('invalidRange')">
                                {{ "common_error.time_error.message" | translate }}
                              </mat-error>
                              @if(shiftCtrl.get('firstSlotStartTime')?.hasError('invalidDaySlot') || shiftCtrl.get('firstSlotEndTime')?.hasError('invalidDaySlot')){
                              <mat-error class="orgApp-text-center">
                                {{ "duties.create_duty_dialog.content.error.day_time_error" | translate }}
                              </mat-error>
                              }
                              @if(shiftCtrl.get('firstSlotStartTime')?.hasError('invalidNightSlot') || shiftCtrl.get('firstSlotEndTime')?.hasError('invalidNightSlot')){
                              <mat-error class="orgApp-text-center">
                                {{ "duties.create_duty_dialog.content.error.night_time_error" | translate }}
                              </mat-error>
                              }
                              <mat-error class="orgApp-text-center" *ngIf="shiftCtrl.get('firstSlotStartTime')?.hasError('startTooEarly')">
                                {{ 'duties.create_duty_dialog.content.error.start_too_early' | translate }}
                              </mat-error>
                              
                              <mat-error class="orgApp-text-center" *ngIf="shiftCtrl.get('firstSlotEndTime')?.hasError('endTooLate')">
                                {{ 'duties.create_duty_dialog.content.error.end_too_late' | translate }}
                              </mat-error>
                            </div>
                          }
                        </div>
                        @if((selectedDutyType !== 'DAY' && nonContinuousDuty)  || (selectedDutyType === 'DAY' && shiftCtrl.get('shiftType')?.value === 'SECOND_HALF_DAY_DUTY') || (selectedDutyType === 'DAY' && nonContinuousDuty && shiftCtrl.get('shiftType')?.value === 'FULL_DAY_DUTY')){
                          <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-10 orgApp-add-duty-full-width">
                            <div class="orgApp-d-flex orgApp-gap-8 orgApp-add-duty-time-range orgApp-padding-top-4 orgApp-padding-bottom-4 orgApp-padding-right-0 orgApp-padding-left-0 orgApp-add-duty-full-width orgApp-flex-dir-col">
                              <div class="orgApp-d-flex orgApp-gap-8 orgApp-align-i-center orgApp-justify-c-center">
                                <mat-form-field
                                  floatLabel="always"
                                  appearance="outline"
                                  class="orgApp-add-duty-field orgApp-input-field orgApp-add-duty-range-height orgApp-field-rounded orgApp-add-duty-time-border orgApp-padding-left-6"
                                >
                                  <input
                                    class="orgApp-add-duty-time-input orgApp-text-center"
                                    matInput
                                    type="time" (input)="breakHrVal()"
                                    formControlName="secondSlotStartTime"
                                /></mat-form-field>
                                -
                                <mat-form-field
                                  floatLabel="always"
                                  appearance="outline"
                                  class="orgApp-add-duty-field orgApp-input-field orgApp-padding-right-6 orgApp-add-duty-range-height orgApp-field-rounded orgApp-add-duty-time-border"
                                  [ngClass]="{
                                    error:
                                      shiftCtrl.get('secondSlotStartTime')?.hasError('invalidRange') ||
                                      shiftCtrl.get('secondSlotStartTime')?.hasError('sameAsFirstSlotEndTime') ||
                                      shiftCtrl.get('secondSlotEndTime')?.hasError('invalidRange')
                                  }"
                                >
                                  <input
                                    class="orgApp-add-duty-time-input orgApp-text-center"
                                    matInput
                                    type="time" (input)="breakHrVal()"
                                    formControlName="secondSlotEndTime"
                                  />
                                </mat-form-field>
                              </div>
                              <mat-error class="orgApp-text-center" *ngIf="shiftCtrl.get('secondSlotStartTime')?.hasError('invalidRange') || shiftCtrl.get('secondSlotEndTime')?.hasError('invalidRange')">
                                {{ "common_error.time_error.message" | translate }}
                              </mat-error>
                              @if(shiftCtrl.get('secondSlotStartTime')?.hasError('invalidDaySlot') || shiftCtrl.get('secondSlotEndTime')?.hasError('invalidDaySlot')){
                                <mat-error class="orgApp-text-center">
                                  {{ "duties.create_duty_dialog.content.error.day_time_error" | translate }}
                                </mat-error>
                              }
                              @if(shiftCtrl.get('secondSlotStartTime')?.hasError('invalidNightSlot') || shiftCtrl.get('secondSlotEndTime')?.hasError('invalidNightSlot')){
                                <mat-error class="orgApp-text-center">
                                  {{ "duties.create_duty_dialog.content.error.night_time_error" | translate }}
                                </mat-error>
                              }
                              <mat-error class="orgApp-text-center" *ngIf="shiftCtrl.get('secondSlotStartTime')?.hasError('startTooEarly')">
                                {{ 'duties.create_duty_dialog.content.error.start_too_early' | translate }}
                              </mat-error>
                              
                              <mat-error class="orgApp-text-center" *ngIf="shiftCtrl.get('secondSlotEndTime')?.hasError('endTooLate')">
                                {{ 'duties.create_duty_dialog.content.error.end_too_late' | translate }}
                              </mat-error>
                              <mat-error class="orgApp-text-center" *ngIf="shiftCtrl.get('secondSlotStartTime')?.hasError('sameAsFirstSlotEndTime')">
                                {{ "duties.create_duty_dialog.content.error.same_as_first_slot_end_time_error" | translate }}
                              </mat-error>
                            </div>
                          </div>
                        }
                        @if(breakHourError){
                        <div class="orgApp-d-flex orgApp-duties-error-div orgApp-padding-right-8 orgApp-padding-top-8 orgApp-padding-bottom-0 orgApp-padding-left-8 orgApp-gap-8">
                          <div class="orgApp-duties-error-icon-div orgApp-margin-top-4">
                            <svg width="20" height="20">
                              <use xlink:href="#error-warn-icon"></use>
                            </svg>
                          </div>
                          <span>{{ "duties.create_duty_dialog.content.error.time_error" | translate }}</span>
                        </div>
                        }
                      </div>

                      @if(shiftCtrl.get('shiftType')?.value === 'FULL_DAY_DUTY') {
                        <mat-form-field 
                          floatLabel="always"
                          appearance="outline"
                          class="orgApp-add-duty-field orgApp-input-field orgApp-field-rounded-sm orgApp-add-duty-break-width orgApp-add-duty-input-field "
                          
                        >
                          <mat-label class="orgApp-add-d-graphik-text">{{ "duties.create_duty_dialog.content.label.break_hours" | translate }}</mat-label>
                          <input
                            [placeholder]="'duties.create_duty_dialog.content.placeholder.break_hours' | translate"
                            matInput
                            id="breakHours" (input)="breakHrVal()"
                            formControlName="breakHours"
                          />
                        </mat-form-field>
                      }
                    </div>
                  </mat-tab>
                </mat-tab-group>
              </div>
            </div>

            <!-- For NIGHT / MANAGER / PICKET duties -->
            <div *ngIf="selectedDutyType !== 'DAY' || addDutyForm.get('managersDuty')?.value || addDutyForm.get('picketDuty')?.value">
              <!-- Use first shift only -->
              <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-padding-left-24 orgApp-padding-right-24 orgApp-margin-top-16 orgApp-margin-bottom-16" formArrayName="shifts">
                <div [formGroupName]="0" class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16">
                  <div class="orgApp-d-flex orgApp-gap-16">
                    <app-icon-color-picker
                      [icons]="dutyIconList" 
                      [colors]="colorPalette"
                      [readOnlyMode]="shiftsFormArray.at(0).get('sameAsParent')?.value || !canEditDuty || (isDutyMappedToAnyLocationDepartment && !isAppAdmin)"
                      [selectedIcon]="shiftsFormArray.at(0).get('icon')?.value ?? ''"
                      [selectedColor]="shiftsFormArray.at(0).get('colourCode')?.value ?? ''"
                      [iconType]="shiftsFormArray.at(0).get('iconType')?.value"
                      [iconColour]="shiftsFormArray.at(0).get('iconColour')?.value"
                      [shiftType]="shiftsFormArray.at(0).get('shiftType')?.value" 
                      (selectionChange)="onIconColorChange($event, shiftsFormArray.at(0).get('shiftType')?.value )"
                    ></app-icon-color-picker>
                    <div class="orgApp-margin-left-16 orgApp-d-flex orgApp-align-i-center orgApp-gap-8">
                      <mat-slide-toggle [disabled]="(!canEditDuty || (isDutyMappedToAnyLocationDepartment && !isAppAdmin))" class="orgApp-toggle-color"
                        [checked]="shiftsFormArray.at(0).get('inchargeDuty')?.value" (change)="onToggleChange($event,'inchargeDuty')">
                      </mat-slide-toggle>
                      <mat-label class="orgApp-add-d-graphik-text orgApp-add-d-label" [ngClass]="{'orgApp-duties-disabled-label':(!canEditDuty || (isDutyMappedToAnyLocationDepartment && !isAppAdmin))}">
                        {{ "duties.create_duty_dialog.content.label.in_charge_duty" | translate }}
                      </mat-label>
                    </div>
                  </div>
                    
                  <div class="orgApp-d-flex orgApp-gap-16">    
                    <mat-form-field floatLabel="always" appearance="outline"
                      class="orgApp-add-duty-field orgApp-input-field orgApp-field-rounded-sm orgApp-add-duty-code-width orgApp-add-duty-input-field "
                      [ngClass]="{ error: shiftsFormArray.at(0).get('code')?.hasError('invalidFormat') }">
                      <mat-label class="orgApp-add-d-graphik-text">{{ "duties.create_duty_dialog.content.label.code" | translate }}</mat-label>
                      <input placeholder="5200" matInput id="code" formControlName="code" />
                    </mat-form-field>          
                    <mat-form-field
                      floatLabel="always"
                      appearance="outline"
                      class="orgApp-add-duty-field orgApp-input-field orgApp-add-duty-name-width orgApp-add-duty-input orgApp-field-rounded-sm "
                    >
                      <mat-label class="orgApp-add-d-graphik-text">{{ "duties.create_duty_dialog.content.label.name" | translate }}</mat-label>
                      <input
                        matInput
                        id="name"
                        formControlName="name"
                        [placeholder]="('duties.create_duty_dialog.content.placeholder.name' | translate)"
                      />
                      <mat-error *ngIf="shiftsFormArray.at(0)?.get('name')?.hasError('whitespace') && !shiftsFormArray.at(0)?.get('name')?.hasError('required')">
                        {{ "common_error.whitespace_error.message" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div>
                    <mat-form-field
                      floatLabel="always"
                      appearance="outline"
                      class="orgApp-add-duty-field orgApp-input-field orgApp-add-duty-full-width orgApp-field-rounded-sm  orgApp-add-duty-textarea"
                    >
                      <mat-label class="orgApp-add-d-graphik-text">
                        {{ "duties.create_duty_dialog.content.label.description" | translate }}</mat-label>
                      <textarea
                        class="orgApp-add-duty-description"
                        matInput
                        id="description"
                        formControlName="description"
                        [placeholder]="('duties.create_duty_dialog.content.placeholder.description' | translate)"
                      ></textarea>
                    </mat-form-field>
                  </div>

                  <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-8">
                    <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16 orgApp-add-duty-full-width">
                      @if(shiftsFormArray.at(0).get('shiftType')?.value !== 'SECOND_HALF_DAY_DUTY'){<!--Show first slot fields for all cases except second/right half duty-->
                        <div class="orgApp-d-flex orgApp-gap-8 orgApp-flex-dir-col orgApp-add-duty-time-range orgApp-padding-top-4 orgApp-padding-bottom-4 orgApp-padding-right-0 orgApp-padding-left-0 orgApp-add-duty-full-width" >
                          <div class="orgApp-d-flex orgApp-gap-8 orgApp-align-i-center orgApp-justify-c-center">
                            <mat-form-field
                              floatLabel="always"
                              appearance="outline"
                              class="orgApp-add-duty-field orgApp-input-field orgApp-padding-left-6 orgApp-add-duty-range-height orgApp-field-rounded orgApp-add-duty-time-border"
                            >
                              <input
                                class="orgApp-add-duty-time-input orgApp-text-center"
                                matInput
                                type="time" (input)="breakHrVal()"
                                formControlName="firstSlotStartTime"
                              />
                            </mat-form-field>
                            -
                            <mat-form-field
                              floatLabel="always"
                              appearance="outline"
                              class="orgApp-add-duty-field orgApp-input-field orgApp-add-duty-range-height orgApp-field-rounded orgApp-add-duty-time-border orgApp-padding-right-6"
                              [ngClass]="{ error: shiftsFormArray.at(0).get('firstSlotStartTime')?.hasError('invalidRange') || shiftsFormArray.at(0).get('firstSlotEndTime')?.hasError('invalidRange') }"
                            >
                              <input
                                class="orgApp-add-duty-time-input orgApp-text-center"
                                matInput
                                type="time" (input)="breakHrVal()"
                                formControlName="firstSlotEndTime"
                              />
                            </mat-form-field>
                          </div>
                          <mat-error
                            class="orgApp-text-center"
                            *ngIf="shiftsFormArray.at(0)?.get('firstSlotStartTime')?.hasError('invalidRange') || shiftsFormArray.at(0)?.get('firstSlotEndTime')?.hasError('invalidRange')"
                          >
                            {{ "common_error.time_error.message" | translate }}
                          </mat-error>
                          @if(shiftsFormArray.at(0).get('firstSlotStartTime')?.hasError('invalidDaySlot') || shiftsFormArray.at(0).get('firstSlotEndTime')?.hasError('invalidDaySlot')){
                          <mat-error class="orgApp-text-center">
                            {{ "duties.create_duty_dialog.content.error.day_time_error" | translate }}
                          </mat-error>
                          }
                          @if(shiftsFormArray.at(0).get('firstSlotStartTime')?.hasError('invalidNightSlot') ||shiftsFormArray.at(0).get('firstSlotEndTime')?.hasError('invalidNightSlot')){
                          <mat-error class="orgApp-text-center">
                            {{ "duties.create_duty_dialog.content.error.night_time_error" | translate }}
                          </mat-error>
                          }
                          <mat-error class="orgApp-text-center" *ngIf="shiftsFormArray.at(0)?.get('firstSlotStartTime')?.hasError('startTooEarly')">
                            {{ 'duties.create_duty_dialog.content.error.start_too_early' | translate }}
                          </mat-error>
                          
                          <mat-error class="orgApp-text-center" *ngIf="shiftsFormArray.at(0)?.get('firstSlotEndTime')?.hasError('endTooLate')">
                            {{ 'duties.create_duty_dialog.content.error.end_too_late' | translate }}
                          </mat-error>
                        </div>
                      }
                    </div>
                    @if((selectedDutyType !== 'DAY' && nonContinuousDuty)  || (selectedDutyType === 'DAY' && shiftsFormArray.at(0).get('shiftType')?.value === 'SECOND_HALF_DAY_DUTY') || (selectedDutyType === 'DAY' && nonContinuousDuty && shiftsFormArray.at(0).get('shiftType')?.value === 'FULL_DAY_DUTY')){
                      <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-10 orgApp-add-duty-full-width">
                        <div class="orgApp-d-flex orgApp-gap-8 orgApp-add-duty-time-range orgApp-padding-top-4 orgApp-padding-bottom-4 orgApp-padding-right-0 orgApp-padding-left-0 orgApp-add-duty-full-width orgApp-flex-dir-col">
                          <div class="orgApp-d-flex orgApp-gap-8 orgApp-align-i-center orgApp-justify-c-center">
                            <mat-form-field
                              floatLabel="always"
                              appearance="outline"
                              class="orgApp-add-duty-field orgApp-input-field orgApp-add-duty-range-height orgApp-field-rounded orgApp-add-duty-time-border orgApp-padding-left-6"
                            >
                              <input
                                class="orgApp-add-duty-time-input orgApp-text-center"
                                matInput
                                type="time" (input)="breakHrVal()"
                                formControlName="secondSlotStartTime"
                            /></mat-form-field>
                            -
                            <mat-form-field
                              floatLabel="always"
                              appearance="outline"
                              class="orgApp-add-duty-field orgApp-input-field orgApp-padding-right-6 orgApp-add-duty-range-height orgApp-field-rounded orgApp-add-duty-time-border"
                              [ngClass]="{
                                error:
                                  shiftsFormArray.at(0).get('secondSlotStartTime')?.hasError('invalidRange') ||
                                  shiftsFormArray.at(0).get('secondSlotStartTime')?.hasError('sameAsFirstSlotEndTime') ||
                                  shiftsFormArray.at(0).get('secondSlotEndTime')?.hasError('invalidRange')
                              }"
                            >
                              <input
                                class="orgApp-add-duty-time-input orgApp-text-center"
                                matInput
                                type="time" (input)="breakHrVal()"
                                formControlName="secondSlotEndTime"
                              />
                            </mat-form-field>
                          </div>
                          <mat-error class="orgApp-text-center" *ngIf="shiftsFormArray.at(0)?.get('secondSlotStartTime')?.hasError('invalidRange') || shiftsFormArray.at(0)?.get('secondSlotEndTime')?.hasError('invalidRange')">
                            {{ "common_error.time_error.message" | translate }}
                          </mat-error>
                          @if(shiftsFormArray.at(0).get('secondSlotStartTime')?.hasError('invalidDaySlot') || shiftsFormArray.at(0).get('secondSlotEndTime')?.hasError('invalidDaySlot')){
                            <mat-error class="orgApp-text-center">
                              {{ "duties.create_duty_dialog.content.error.day_time_error" | translate }}
                            </mat-error>
                          }
                          @if(shiftsFormArray.at(0).get('secondSlotStartTime')?.hasError('invalidNightSlot') || shiftsFormArray.at(0).get('secondSlotEndTime')?.hasError('invalidNightSlot')){
                            <mat-error class="orgApp-text-center">
                              {{ "duties.create_duty_dialog.content.error.night_time_error" | translate }}
                            </mat-error>
                          }
                          <mat-error class="orgApp-text-center" *ngIf="shiftsFormArray.at(0).get('secondSlotStartTime')?.hasError('startTooEarly')">
                            {{ 'duties.create_duty_dialog.content.error.start_too_early' | translate }}
                          </mat-error>
                          
                          <mat-error class="orgApp-text-center" *ngIf="shiftsFormArray.at(0)?.get('secondSlotEndTime')?.hasError('endTooLate')">
                            {{ 'duties.create_duty_dialog.content.error.end_too_late' | translate }}
                          </mat-error>
                          <mat-error class="orgApp-text-center" *ngIf="shiftsFormArray.at(0)?.get('secondSlotStartTime')?.hasError('sameAsFirstSlotEndTime')">
                            {{ "duties.create_duty_dialog.content.error.same_as_first_slot_end_time_error" | translate }}
                          </mat-error>
                        </div>
                      </div>
                    }
                    @if(breakHourError){
                    <div class="orgApp-d-flex orgApp-duties-error-div orgApp-padding-right-8 orgApp-padding-top-8 orgApp-padding-bottom-0 orgApp-padding-left-8 orgApp-gap-8">
                      <div class="orgApp-duties-error-icon-div orgApp-margin-top-4">
                        <svg width="20" height="20">
                          <use xlink:href="#error-warn-icon"></use>
                        </svg>
                      </div>
                      <span>{{ "duties.create_duty_dialog.content.error.time_error" | translate }}</span>
                    </div>
                    }
                  </div>

                    <!-- @if(showBreakHoursInput) { -->
                      <mat-form-field 
                        floatLabel="always"
                        appearance="outline"
                        class="orgApp-add-duty-field orgApp-input-field orgApp-field-rounded-sm orgApp-add-duty-break-width orgApp-add-duty-input-field "
                        
                      >
                        <mat-label class="orgApp-add-d-graphik-text">{{ "duties.create_duty_dialog.content.label.break_hours" | translate }}</mat-label>
                        <input
                          [placeholder]="'duties.create_duty_dialog.content.placeholder.break_hours' | translate"
                          matInput
                          id="breakHours" (input)="breakHrVal()"
                          formControlName="breakHours"
                        />
                      </mat-form-field>
                    <!-- } -->
                </div>
              </div>
            </div>
            <!-- @if(showBreakHoursInput) {
              <mat-form-field [ngClass]="{ error: (breakHoursCtrl?.touched || breakHoursCtrl?.dirty) && breakHoursCtrl?.invalid }"
                floatLabel="always"
                appearance="outline"
                class="orgApp-add-duty-field orgApp-input-field orgApp-field-rounded-sm orgApp-add-duty-break-width orgApp-add-duty-input-field  orgApp-margin-left-24"
                
              >
                <mat-label class="orgApp-add-d-graphik-text">{{ "duties.create_duty_dialog.content.label.break_hours" | translate }}</mat-label>
                <input
                  [placeholder]="'duties.create_duty_dialog.content.placeholder.break_hours' | translate"
                  matInput
                  id="breakHours" (input)="breakHrVal()"
                  formControlName="breakHours"
                />
              </mat-form-field>
            } -->
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="orgApp-d-flex orgApp-add-d-footer">
    <div class="orgApp-margin-left-16 orgApp-d-flex orgApp-align-i-center orgApp-gap-8">
      <mat-slide-toggle [disabled]="(!canEditDuty || (isDutyMappedToAnyLocationDepartment && !isAppAdmin))"
        class="orgApp-toggle-color"
        [checked]="getActiveValue()"
        (change)="onToggleChange($event,'active')"
      >
      </mat-slide-toggle>
      <mat-label class="orgApp-add-d-graphik-text" [ngClass]="{'orgApp-duties-disabled-label':(!canEditDuty || (isDutyMappedToAnyLocationDepartment && !isAppAdmin))}">
        {{ "duties.create_duty_dialog.content.label.active" | translate }}
      </mat-label>
    </div>
    <div class="orgApp-margin-right-16 orgApp-d-flex orgApp-gap-8">
      <button
        mat-stroked-button
        class="orgApp-add-d-ftr-btn orgApp-add-d-close-btn orgApp-modal-button orgApp-add-d-graphik-text"
        (click)="cancelForm()"
      >
      @if(canEditDuty && (!isDutyMappedToAnyLocationDepartment || isAppAdmin)){
        {{ "duties.create_duty_dialog.action.cancel_btn" | translate }}
      }@else{
        {{ "duties.create_duty_dialog.action.close_btn" | translate }}
      }
      </button>
      @if(canEditDuty && (!isDutyMappedToAnyLocationDepartment || isAppAdmin)){
      <button
        mat-raised-button
        [ngClass]="{ disable: !addDutyForm.valid }"
        class="orgApp-raised-btn-primary orgApp-add-d-ftr-btn orgApp-add-d-create-btn orgApp-modal-button orgApp-add-d-graphik-text"
        (click)="submitForm()"
        [disabled]="!addDutyForm.valid || !addDutyForm.dirty || breakHourError || ((!addDutyForm.value?.picketDuty && !addDutyForm.value?.managersDuty) && (!hasAtLeastOneShiftSelected && selectedDutyType == 'DAY'))"
      >
        {{ editFormData.button | translate }}
      </button>
     }
    </div>
  </mat-dialog-actions>
</div>
